import { TextMessage } from '../TextMessage/TextMessage';

export const FailedLoad = () => {
  return <TextMessage text="Bilinmeyen bir problem oluştu..." />;
};
